"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sync = void 0;
exports.sync = function (synchronousObservable) {
    var result;
    synchronousObservable.subscribe(function (val) { return result = val; }).unsubscribe();
    return result;
};
